/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailScheduleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Email Schedule',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.875 2H1.125A1.147 1.147 0 0 0 0 3.167v1.468l18 13.553L36 4.665v-1.5A1.147 1.147 0 0 0 34.875 2ZM0 7.511v16.684l11.165-8.257L0 7.511zM16.71 20.094l-3.628-2.719L0 27.068v1.765A1.147 1.147 0 0 0 1.125 30h13.959a12.191 12.191 0 0 1 1.708-9.863c-.025-.018-.057-.024-.082-.043ZM27 14.7a12.253 12.253 0 0 1 9 3.935V7.541l-9.577 7.188c.193-.009.382-.029.577-.029ZM27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9ZM27 34a7 7 0 0 1-1-13.929v7.136a.674.674 0 0 0 .2.476l2.9 2.9a.673.673 0 0 0 .953 0l.9-.9a.674.674 0 0 0 0-.953l-2.054-2.054a.675.675 0 0 1-.2-.476v-5.993A7 7 0 0 1 27 34Z"
    />
  </svg>`;
};
